"use strict";

var _regeneratorRuntime = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _taggedTemplateLiteral = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _classCallCheck = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n        subscription {\n          output: subscribeGasPrice\n        }"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n        subscription (\n          $key: String!\n        ) {\n          output: subscribeRelayedTransaction(\n            key: $key\n          ) {\n            key\n            state\n            hash\n          }\n        }"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n        mutation (\n          $to: String!\n          $data: String!\n          $signature: String!\n          $gas: Float!\n          $gasPrice: BN!\n        ) {\n          output: relayTransaction(\n            to: $to\n            data: $data\n            signature: $signature\n            gas: $gas\n            gasPrice: $gasPrice\n          )\n        }"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        query (\n          $address: String!\n          $amount: BN!\n        ) {\n          output: calcSupportedTokenAmount (\n            address: $address\n            amount: $amount\n          )\n        }"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        mutation (\n          $to: String!\n          $data: String!\n        ) {\n          output: estimateTransaction(\n            to: $to\n            data: $data\n          ) {\n            gas\n            signature\n          }\n        }"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        query {\n          output: getSettings {\n            transaction {\n              estimationRefundAmount\n              estimationGasPrice\n            }\n          }\n        }"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        query {\n          output: getGasPrice\n        }"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var apollo_boost_1 = require("apollo-boost");

var eth_sdk_1 = require("eth-sdk");

var AbstractGraphQLClient_1 = require("./AbstractGraphQLClient");

var RelayerClient = /*#__PURE__*/function (_AbstractGraphQLClien) {
  _inherits(RelayerClient, _AbstractGraphQLClien);

  var _super = _createSuper(RelayerClient);

  function RelayerClient() {
    _classCallCheck(this, RelayerClient);

    return _super.apply(this, arguments);
  }

  _createClass(RelayerClient, [{
    key: "getGasPrice",
    value: function getGasPrice() {
      return this.query(apollo_boost_1.gql(_templateObject())).then(function (output) {
        return eth_sdk_1.toBN(output);
      });
    }
  }, {
    key: "getBatchModuleOptions",
    value: function getBatchModuleOptions() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _yield$this$query, _yield$this$query$tra, estimationRefundAmount, estimationGasPrice;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.query(apollo_boost_1.gql(_templateObject2()));

              case 2:
                _yield$this$query = _context.sent;
                _yield$this$query$tra = _yield$this$query.transaction;
                estimationRefundAmount = _yield$this$query$tra.estimationRefundAmount;
                estimationGasPrice = _yield$this$query$tra.estimationGasPrice;
                return _context.abrupt("return", {
                  estimationRefundAmount: eth_sdk_1.toBN(estimationRefundAmount),
                  estimationGasPrice: eth_sdk_1.toBN(estimationGasPrice)
                });

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "estimateTransaction",
    value: function estimateTransaction(options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this.mutate(apollo_boost_1.gql(_templateObject3()), options));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "calcSupportedTokenAmount",
    value: function calcSupportedTokenAmount(options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this.query(apollo_boost_1.gql(_templateObject4()), options).then(function (output) {
                  return eth_sdk_1.toBN(output);
                }));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "relayTransaction",
    value: function relayTransaction(options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", this.mutate(apollo_boost_1.gql(_templateObject5()), options));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "subscribeRelayedTransaction",
    value: function subscribeRelayedTransaction(key) {
      return this.subscribe(apollo_boost_1.gql(_templateObject6()), {
        key: key
      });
    }
  }, {
    key: "subscribeGasPrice",
    value: function subscribeGasPrice() {
      return this.subscribe(apollo_boost_1.gql(_templateObject7())).map(function (output) {
        return eth_sdk_1.toBN(output);
      });
    }
  }]);

  return RelayerClient;
}(AbstractGraphQLClient_1.AbstractGraphQLClient);

exports.RelayerClient = RelayerClient;